<!-- 
程式：CarFireInsuranceReserveDataTable.vue
功能：車火險預約單表格
作者：i9400520
完成：2019-01-07
-->
<template>
  <section class="newTable">
    <table
      class="table datatable table-striped area-list-datatable"
      id="PrecisionMarketingDataTable"
    >
      <thead>
        <tr>
          <th width="120">
            <div class="checkbox checkbox-inline mr-0">
              <input
                @click="clickTarget = clickTarget === `clickAll`? `clickAll-again`: `clickAll`"
                type="checkbox"
                name="check-all"
                id="check-all"
                value="1"
                v-model="checkAll"
              >
              <label for="check-all"></label>
            </div>
            <span>#</span>
          </th>
          <th
            width="*"
            :class="'sorting ' + (order.fieldName === 'customer_name' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
            @click="columnSorting('customer_name')"
          >姓名</th>
          <th
            width="*"
            :class="'sorting ' + (order.fieldName === 'customer_birthday' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
            @click="columnSorting('customer_birthday')"
          >生日</th>
          <th
            width="*"
            :class="'sorting ' + (order.fieldName === 'customer_day_phone' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
            @click="columnSorting('customer_day_phone')"
          >客戶電話</th>
          <th
            width="*"
            :class="'sorting ' + (order.fieldName === 'customer_cellular_phone' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
            @click="columnSorting('customer_cellular_phone')"
          >客戶手機</th>
          <th
            width="*"
            :class="'sorting ' + (order.fieldName === 'edate' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
            @click="columnSorting('edate')"
          >最新預約日期</th>
          <th
            width="*"
            :class="'sorting ' + (order.fieldName === 'is_car' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
            @click="columnSorting('is_car')"
          >車險預約</th>
          <th
            width="152"
            :class="'sorting ' + (order.fieldName === 'is_fire' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
            @click="columnSorting('is_fire')"
          >火險預約</th>
        </tr>
      </thead>
      <tbody @scroll="scrollmethod" class="block-height" :style="{height: height + 'px'}">
        <tr
          v-for="(d, did) in tableDataBackup"
          :key="`CarFireInsuranceReserveDataTable-table-td-${did}`"
        >
          <td width="120">
            <div style="min-height: 30px;">
              <div class="mr-0 checkbox checkbox-inline">
                <input
                  @click="clickTarget = clickTarget === `td-${did}`? `td-${did}-again`: `td-${did}`"
                  type="checkbox"
                  name="`td-item[]`"
                  :id="`CarFireInsuranceReserveDataTable-check-${did}`"
                  :value="d.customer_id"
                  v-model="selection"
                  :disabled="d.customer_id === ''"
                  @change="$emit('update', selection)"
                >
                <label :for="`CarFireInsuranceReserveDataTable-check-${did}`"></label>
              </div>

              <span>
                <span class="no">{{did + 1}}</span>
                <span class="info text-center">
                  <avatar :gender="Number(d.customer_sex)" :size="20"/>
                </span>
              </span>
            </div>
          </td>
          <td width="*">
            <Tooltip  :position="did < 3 ?'bottom':'top'" :name="d.customer_name" :mobile="d.customer_day_phone" :phone="d.customer_cellular_phone" :birthday="d.customer_birthday">
              <a v-if="d.is_exist" @click.prevent="routerToCust(d.customer_id, d.customer_name)" class="link text-underline">{{d.customer_name | getMaskName}}</a>
              <a v-else>{{d.customer_name | getMaskName}}</a>
            </Tooltip>
          </td>
          <td width="*">
            <span>
                <div class="date">{{d.customer_birthday | dateFormat | getMaskBirthday}}</div>
                <div class="age">
                  <b>{{ d.age? d.age : '— —' }}</b>
                  <span v-if="d.age">歲</span>
                  <span v-else></span>
                </div>
              </span>
          </td>
          <td width="*">{{d.customer_day_phone | getMaskMobile}}</td>
          <td width="*">{{d.customer_cellular_phone | getMaskPhone}}</td>
          <td width="*">{{d.edate | dateFormat}}</td>
          <td width="*">
            <a
              class="text-green text-underline pointer-cursor"
              v-if="d.is_car === 'Y'"
              @click="$emit('openCarReserveModal',d)"
            >查詢</a>
            <template v-else>— —</template>
          </td>
          <td width="138">
            <a
              class="text-green text-underline pointer-cursor"
              v-if="d.is_fire === 'Y'"
              @click="$emit('openFireReserveModal',d)"
            >查詢</a>
            <template v-else>— —</template>
          </td>
        </tr>
        <tr v-if="tableDataBackup.length == 0">
          <td colspan="8" class="text-center pt-3 pb-5">
            <h3>無客戶名單資料</h3>
          </td>
          <td style="display: none;"></td>
          <td style="display: none;"></td>
          <td style="display: none;"></td>
          <td style="display: none;"></td>
          <td style="display: none;"></td>
          <td style="display: none;"></td>
          <td style="display: none;"></td>
        </tr>
      </tbody>
    </table>
  </section>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Level from "@/components/Level";
import Avatar from "@/components/Avatar";
import { commonMixin } from "@/mixins/common";
import { setTimeout } from "timers";
import Tooltip from "@/desktop/components/ToolTip";
const is_iPad = navigator.userAgent.match(/iPad/i) != null; // 確認裝置是否為 iPad
let idmarkWidth = 148;
if (is_iPad) {
  idmarkWidth = 131;
}

export default {
  name: "CarFireInsuranceReserveDataTable",
  mixins: [commonMixin],
  components: { Level, Avatar, Tooltip },
  props: {
    tableData: {
      type: Array,
      default: () => {
        return [];
      }
    },
    height: {
      type: Number,
      default: () => {
        return 350;
      }
    }
  },
  data() {
    return {
      order: {
        fieldName: "name",
        asc: true
      },
      checkAll: false,
      clickTarget: "",
      tableDataBackup: [],
      allIdData: [],
      selection: [],
      currentWidth: 0,
      is_iPad: is_iPad,
      iPadWidth: idmarkWidth
    };
  },
  watch: {
    tableData: function() {
      this.init();
    },
    clickTarget: function(target) {
      if (target === "clickAll" || target === "clickAll-again") {
        //點了全選checkbox
        if (this.checkAll) {
          //點了全選
          this.selection = [];
          this.allIdData.forEach((data) => {
            this.selection.push(data);
          });
        } else {
          //取消全選
          this.selection = [];
        }
      } else {
        //點了其他checkbox
        this.checkAll = this.selection.length == this.allIdData.length;
      }
      this.$emit("update", this.selection);
    }
  },
  computed: {
    ...mapGetters([ 'UserInfo' ]),
    isBox() {
      //判斷是否為box
      return this.UserInfo.userType === 'box';
    }
  }, 
  methods: {
    ...mapActions(["setPageLock", "updateCustID"]),
    scrollmethod(e) {
      // this.nowTime = +new Date()
      // if(this.nowTime > this.lastTime + 150){
      //   this.lastTime = this.nowTime
      //   if (!this.scrollDataLoading && e.target.scrollTop > (e.target.scrollHeight - 700)) {
      //     this.options.scrollLoadingAPI()
      //   }
      // }
    },
    columnSorting(fieldName) {
      //切換表頭圖案
      if (this.order.fieldName == fieldName) {
        this.order.asc = !this.order.asc;
      } else {
        this.order.fieldName = fieldName;
        this.order.asc = true;
      }

      //data排序
      let sortOrder = -1;
      if (this.order.asc) {
        sortOrder = 1;
      }

      switch (fieldName) {
        case 'customer_birthday':
          this.tableDataBackup = []  
          setTimeout(() => {
            this.tableDataBackup = [...this.tableData]  
            this.tableDataBackup.sort(this.sortCompareFun(sortOrder, "birthdaySort"))
            this.registerHanlink()  // for 難字更新
          }, 20)
            break;
        default:
          this.tableDataBackup = [];
          setTimeout(() => {
            this.tableDataBackup = [...this.tableData];
            this.tableDataBackup.sort(
              this.sortCompareFun(sortOrder, fieldName)
            );
            this.registerHanlink(); // for 難字更新
          }, 20);
      }
    },
    sortCompareFun(sortOrder, property) {
      return function(a, b) {
        let result =
          a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
        return result * sortOrder;
      };
    },
    routerToCust(custID, custName) {
      if (this.isBox) {
        //若内嵌於Box, 將客戶資訊回傳給Box
        this.boxCustInfo(custID, custName);
      } else {
        this.updateCustID(custID);
        localStorage.CustID = custID;
        this.$router.push({ path: `/detail/CustID/tab/1` });
      }
    },
    init() {
      this.checkAll = false;
      this.selection = [];
      this.tableDataBackup = this.tableData.map((ele) => {
        return ele;
      });
      this.allIdData = this.tableData.map((ele) => {
        return ele.customer_id;
      });
      this.registerHanlink(); // for 難字更新
    }
  },
  mounted() {
    this.currentWidth =
      this.$el.clientWidth * (this.$el.clientWidth < 1250 ? 0.95 : 1);
    if (!is_iPad) {
      this.iPadWidth = "131";
    } else {
      this.iPadWidth = "148";
    }
  }
};
</script>

<style lang="scss" scoped>
.newTable thead tr,
.newTable tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
  border-left: 0;
  border-right: 0;
  border-bottom: 0;

  td {
    word-break: break-all;
  }

  &.sorting,
  &.sorting_desc {
    position: relative;
    padding-right: 25px !important;

    &:before,
    &:after {
      content: "";
      position: absolute;
      width: 0px;
      height: 0px;
      display: block;
      top: 0;
      bottom: 0;
      right: 6px;
      margin: auto;
    }

    &:after {
      top: 18px;
      border-top: 6px solid transparentize(#027a39, 0.5);
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-bottom: 6px solid transparent;
    }

    &:before {
      top: -13px;
      border-bottom: 6px solid transparentize(#027a39, 0.5);
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-top: 6px solid transparent;
    }
  }

  &.sorting_asc:before {
    border-bottom: 6px solid transparentize(white, 0.5);
  }

  &.sorting_desc:after {
    border-top: 6px solid transparentize(white, 0.5);
  }

  &.no-sort:before,
  &.no-sort:after {
    display: none;
  }
}

.newTable tbody.block-height {
  display: block;
  height: 350px;
  overflow-y: scroll;
  border: 0 !important;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    width: 17px;
    border: 0;
    box-shadow: none;
  }

  &::-webkit-scrollbar-track {
    box-shadow: none;
    border-radius: 0px;
    border: 0;
    background-color: #f5f5f5;
  }

  &::-webkit-scrollbar-thumb {
    width: 10px;
    border-radius: 20px;
    background-color: #555;
  }
}
</style>
